/**
 * Contexto de los avisos, aparte del componente que lo provee.
 *
 * Vive en su propio archivo para no romper el fast refresh: un modulo que
 * exporta componentes y ademas hooks o funciones pierde el recargado en
 * caliente de React.
 */

import { createContext, useContext } from 'react'

export type Tono = 'exito' | 'error' | 'info'

export interface Aviso {
  id: number
  tono: Tono
  texto: string
  detalle?: string
  /** Accion de deshacer, cuando la operacion es reversible. */
  deshacer?: { etiqueta: string; fn: () => void }
}

export interface ApiAvisos {
  exito: (texto: string, opciones?: Omit<Aviso, 'id' | 'tono' | 'texto'>) => void
  error: (texto: string, detalle?: string) => void
  info: (texto: string) => void
}

export const ContextoAvisos = createContext<ApiAvisos | null>(null)

export function useAvisos(): ApiAvisos {
  const api = useContext(ContextoAvisos)
  if (!api) throw new Error('useAvisos necesita estar dentro de <ProveedorAvisos>.')
  return api
}

/** Traduce el error de una mutacion a un mensaje mostrable. */
export function mensajeDeError(error: unknown): string {
  return error instanceof Error ? error.message : 'Ocurrio un error inesperado.'
}
